<template>
    <carousel
      :per-page="itemPerPage"
      :mouse-drag="false"
      :navigation-enabled="navigationEnabled"
      :loop="true"
      :autoplay="true"
      autoplayTimeout="2500"
      pagination-active-color="#1F4E78"
    >
      <slide
        v-for="(testimonial, index) of listItems"
        :key="index"
      >
        <div class="item-card">
          <!-- <div
            class="card-text"
            v-html="testimonial.text"
          ></div> -->
          <!-- <small style="font-size: 9px;"><a
              href="https://www.g2.com/products/enginehire/reviews"
              target="_blank"
            >Read full review</a></small> -->
          <div class="card-image-container">
            <img
              :src="
                // require(`../assets/img/home/customers/${testimonial.img.src}`)
                require(`../assets/img/${testimonial.img.src}`)
              "
              width="100%"
              height=""
              :alt="testimonial.img.alt"
              class="card-image"
            />
          </div>
          <!-- <div class="card-person-info">{{ testimonial.personInfo }}</div>
          <div class="card-person-link">
            <a
              :href="testimonial.link.url"
              target="_blank"
            >
              {{ testimonial.link.text }}
            </a>
          </div> -->
        </div>
      </slide>
    </carousel>
  </template>
  <script>
  import { Carousel, Slide } from "vue-carousel";
  export default {
    name: "CarouselComponent",
    components: {
      Carousel,
      Slide,
    },
    props: {
      listItems: Array,
      itemPerPage: Number,
      navigationEnabled: {
        type: Boolean,
        default: true,
      },
    },
  };
  </script>
  
  <style scoped>
  .item-card {
    /* box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15); */
    /* margin: 5px 15px; */
    /* padding: 2.5em; */
    height: 100%;
  }
  
  .card-image-container {
    /* margin-top: 25px; */
    margin: 0;
  }
  
  .card-person-info {
    text-align: center;
  }
  
  .card-person-link {
    text-align: center;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/CarouselImageComponent.vue